<nb-card>
  <nb-card-header>
    <h6 class="text-heading" *ngIf="sourceType === ''">
      {{ course.title }}
    </h6>
    <h6 class="text-heading" *ngIf="sourceType !== '' && selectedLecture">
      Bài {{ selectedLecture.positionOrd }}: {{ selectedLecture.title }}
    </h6>

    <button
      class="close"
      nbButton
      status="danger"
      size="small"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <div class="row">
      <div class="col-md-8">
        <ngx-view-image
          *ngIf="sourceType === ''"
          [imageURL]="course.coverUrl"
        ></ngx-view-image>

        <ngx-view-course-content
          *ngIf="sourceType !== ''"
          [course]="course"
          [lecture]="content"
        ></ngx-view-course-content>
      </div>

      <div class="col-md-4">
        <ngx-preview-sections
          [courseId]="courseId"
          [sourceType]="sourceType"
          [lectureContentId]="lectureContentId"
          [sections]="sections"
          (onOpenSourceContent)="openSourceContent($event)"
        ></ngx-preview-sections>
      </div>
    </div>
  </nb-card-body>
</nb-card>
